export default __webpack_public_path__ + "static/media/oli-sharEnergy.6c54d4f9.png";